import { organizationApi } from '../services/api'

const emptyPassword = () => ({ new_password: '', confirm_password: '' })

export default {
  data () {
    return {
      passwordVisible: false,
      passwordSaving: false,
      passwordTarget: null,
      passwordForm: emptyPassword(),
      passwordRules: {
        new_password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, max: 64, message: '密码长度须为 8 至 64 位', trigger: 'blur' }
        ],
        confirm_password: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    openPassword (person) {
      this.passwordTarget = { sjid: person.sjid, display_name: person.display_name }
      this.passwordForm = emptyPassword()
      this.passwordVisible = true
      this.$nextTick(() => { if (this.$refs.passwordForm) this.$refs.passwordForm.clearValidate() })
    },
    clearPassword () {
      this.passwordForm = emptyPassword()
      this.passwordTarget = null
    },
    savePassword () {
      if (!this.passwordTarget || this.passwordSaving) return
      this.$refs.passwordForm.validate(async valid => {
        if (!valid || this.passwordSaving) return
        if (this.passwordForm.new_password !== this.passwordForm.confirm_password) {
          this.$message.error('两次输入的新密码不一致')
          return
        }
        this.passwordSaving = true
        try {
          await organizationApi.changePersonnelPassword({ sjid: this.passwordTarget.sjid, new_password: this.passwordForm.new_password })
          const isSelf = String(this.passwordTarget.sjid) === String(this.$store.state.user && this.$store.state.user.sjid)
          this.passwordVisible = false
          if (isSelf) {
            this.$store.commit('session', null)
            this.$router.push('/login')
            this.$message.success('密码已修改，请使用新密码重新登录')
          } else {
            this.$message.success('密码已修改，该人员需要重新登录')
          }
        } catch (error) {
          this.$message.error(error.message)
        } finally {
          this.passwordSaving = false
        }
      })
    }
  }
}
